import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserService } from '../../user/services/user.service';

@Pipe({
  name: 'user'
})
export class UserPipe implements PipeTransform {

  constructor(private _userService: UserService){ }

  transform(userId: string): Observable<string> {
    if(!userId) return of(null);
    return this._userService.getUserById(userId, true).pipe(map(x => x.userName));
  }

}
